<template>
  <panel :class="data.colSpan" :no-padding="noPadding" :title="data.title">
    <template slot="actions">
      <div class="flex space-x-2">
        <span v-if="$slots['custom-icon']">
          <slot name="custom-icon"></slot>
        </span>
        <a v-if="exportPdf"
           class="text-gray-500 hover:text-blue-600"
           href="#"
           title="Export PDF"
           @click="exportFile('pdf')"
           target="_self">
          <pdf-icon class="w-6 h-6"></pdf-icon>
        </a>
        <a v-if="exportCsv"
           class="text-gray-500 hover:text-blue-600"
           href="#"
           title="Export XSLX"
           @click="exportFile('csv')"
           target="_self">
          <excel-icon class="w-6 h-6"></excel-icon>
        </a>
        <a v-if="showRefresh"
           class="text-gray-500 hover:text-blue-600 cursor-pointer"
           :class="syncSpin"
           @click="startRefresh">
          <sync-icon class="w-6 h-6"></sync-icon>
        </a>
      </div>
    </template>
    <slot></slot>
    <div v-if="$slots['buttons']" slot="buttons">
      <slot name="buttons"></slot>
    </div>
  </panel>
</template>
<script>
export default {
    name: "gadget-box",
    props: {
        data: {type: Object, required: true},
        exportCsv: {type: Boolean, default: false},
        exportPdf: {type: Boolean, default: false},
        noPadding: {type: Boolean, default: false},
        showRefresh: {type: Boolean, default: true}
    },
    data() {
        return {
            _gadgetBox: true,
            loading: false
        }
    },
    computed: {
        syncSpin() {
            return this.loading ? 'animate-spin' : 'animate-none';
        },
        componentUrl() {
            let component = this.data.component.split('-');
            return '/gadget/' + component.shift() + '/' + component.join('-');
        }
    },
    methods: {
        exportFile(type) {
            this.$emit('export', type);
        },
        startRefresh() {
            this.loading = true;
            this.$emit('refresh');
        },
        stopRefresh() {
            this.loading = false;
        }
    }
}
</script>